var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgFaceSmile = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "face-smile 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "face-smile",
    d: "M12 22.75C6.072 22.75 1.25 17.928 1.25 12C1.25 6.072 6.072 1.25 12 1.25C17.928 1.25 22.75 6.072 22.75 12C22.75 17.928 17.928 22.75 12 22.75ZM12 2.75C6.899 2.75 2.75 6.899 2.75 12C2.75 17.101 6.899 21.25 12 21.25C17.101 21.25 21.25 17.101 21.25 12C21.25 6.899 17.101 2.75 12 2.75ZM16.25 10C16.25 8.986 15.725 8.25 15 8.25C14.275 8.25 13.75 8.986 13.75 10C13.75 11.014 14.275 11.75 15 11.75C15.725 11.75 16.25 11.014 16.25 10ZM10.25 10C10.25 8.986 9.725 8.25 9 8.25C8.275 8.25 7.75 8.986 7.75 10C7.75 11.014 8.275 11.75 9 11.75C9.725 11.75 10.25 11.014 10.25 10ZM16.597 15.454C16.848 15.124 16.784 14.654 16.454 14.403C16.123 14.152 15.653 14.217 15.403 14.546C14.58 15.629 13.339 16.25 12 16.25C10.678 16.25 9.41 15.614 8.609 14.549C8.361 14.219 7.893 14.15 7.558 14.401C7.227 14.65 7.161 15.12 7.41 15.451C8.493 16.891 10.209 17.75 12 17.75C13.812 17.75 15.487 16.913 16.597 15.454Z"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFaceSmile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/face-smile.27390dac.svg";
export { ForwardRef as ReactComponent };